import { render, staticRenderFns } from "./GeneralGeometryForm.vue?vue&type=template&id=493dae0c&"
import script from "./GeneralGeometryForm.vue?vue&type=script&lang=js&"
export * from "./GeneralGeometryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports